import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomerOrderService } from '@app/core/services/customer-order/customer-order.service';
import { AlertDialogComponent } from '@app/shared/components/alert-dialog/alert-dialog.component';
import { LoadingSpinnerComponent } from '@app/shared/components/loading-spinner/loading-spinner.component';
import { MobileNumberInputComponent } from '@app/shared/components/mobile-number-input/mobile-number-input.component';
import { TextAreaInputComponent } from '@app/shared/components/text-area-input/text-area-input.component';
import { TextInputComponent } from '@app/shared/components/text-input/text-input.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-raise-reach-date-dispute-page',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextInputComponent,
    MobileNumberInputComponent,
    TextAreaInputComponent,
    LoadingSpinnerComponent,
  ],
  templateUrl: './raise-reach-date-dispute.component.html',
  styleUrl: './raise-reach-date-dispute.component.scss',
})
export class RaiseReachDateDisputeComponent implements OnInit, OnDestroy {
  isLoading!: boolean;
  id!: string;
  deliveryDate: any;
  message: string = '';
  disputeRaised: boolean = false;
  hasUserRaisedDispute: boolean = false;
  invoiceNum: string = '';

  disputeForm!: FormGroup;
  private routeSub!: Subscription;

  constructor(
    private customerOrderService: CustomerOrderService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    this.isLoading = true;
  }

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.loadConfirmationStatus();
    });

    this.disputeForm = this.fb.group({
      name: ['', Validators.required],
      role: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      poNum: ['', Validators.required],
      reason: ['', Validators.required],
    });
  }

  private loadConfirmationStatus(): void {
    this.customerOrderService.getReachDateDispute(this.id).subscribe({
      next: (data) => {
        this.hasUserRaisedDispute = data.hasReachDateDispute;
        this.deliveryDate = data.customerInvoice?.reachDate;
        this.invoiceNum = data.customerInvoice?.invoiceNum;
        if (this.hasUserRaisedDispute) {
          this.message = 'You’ve already raised dispute.';
          this.disputeRaised = true;
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Error',
            message: error?.error?.detail || JSON.stringify(error?.error ? error?.error : error),
          },
        });
      },
    });
  }

  ngOnDestroy(): void {
    if (this.routeSub) this.routeSub.unsubscribe();
  }

  onRaiseDispute(): void {
    if (!this.id || this.disputeForm.invalid) return;

    const payload = {
      public_id: this.id,
      reach_date: this.deliveryDate,
      ...this.disputeForm.value,
    };

    this.customerOrderService.postReachDateDispute(payload).subscribe({
      next: () => {
        this.message = 'Dispute has been raised successfully.';
        this.disputeRaised = true;
      },
    });
  }
}
